import React, { JSX } from 'react';
import { IStepsTypes } from '../../typings';

export const StepProgress: React.FC<{ steps: IStepsTypes[]; currentStep: IStepsTypes }> = ({ steps = [], currentStep = 'deviceId' }) => {

  const stepsToRender: JSX.Element[] = [];
  for(const step of steps) {
    const index = steps.findIndex((s) => s === step) + 1;
    if(step === 'final') {
      stepsToRender.push(<div key={step} className={`step-bullet ${step === currentStep ? 'active' : ''}`}><svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.18359 7.94531L12.1289 0L13.1836 1.05469L4.18359 10.0547L0 5.87109L1.05469 4.81641L4.18359 7.94531Z" fill="#005F70"/></svg></div>);
    } else if (step === 'gcl') {
      stepsToRender.push(<div key={step} className={`step-bullet ${step === currentStep ? 'active' : ''}`}>{index}</div>);
      stepsToRender.push(<div key={step} className={'extra'}><span>-</span><div className='card-bullet'><svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2.6875V1.34375H1.3125V2.6875H12ZM12 9.34375V5.34375H1.3125V9.34375H12ZM12 0C12.375 0 12.6875 0.135417 12.9375 0.40625C13.1875 0.65625 13.3125 0.96875 13.3125 1.34375V9.34375C13.3125 9.71875 13.1875 10.0417 12.9375 10.3125C12.6875 10.5625 12.375 10.6875 12 10.6875H1.3125C0.9375 10.6875 0.625 10.5625 0.375 10.3125C0.125 10.0417 0 9.71875 0 9.34375V1.34375C0 0.96875 0.125 0.65625 0.375 0.40625C0.625 0.135417 0.9375 0 1.3125 0H12Z" fill="#005F70"/></svg></div><span>-</span></div>);
    } else if(step === 'after_gcl') {
      stepsToRender.push(<div key={step} className={`step-bullet ${step === currentStep ? 'active' : ''}`}>{index}</div>);
    } else {
      stepsToRender.push(<div key={step} className={`step-bullet ${step === currentStep ? 'active' : ''}`}>{index}</div>);
    }
  }
  return (
    <div className="step-progress">
      <span className='steps-numof'>Step {steps.findIndex((s) => s === currentStep) + 1} of {steps.length}</span>
      <div className='steps-nums'>
        {stepsToRender.map((step) => (
          <>
            {step}
          </>
        ))}
      </div>
    </div>
  );
};
